import { ProjectNeedsSchema } from '@axiom/validation';
import { z } from 'zod';
import { SchemaLocation, ZodArrayToEnum } from '@axiom/types';
import { selfServiceAllowedCountryCodeValues } from '@axiom/const';

export const TalentInterviewMiniIntakeModalSchema = ProjectNeedsSchema.pick({
  billingUnitsPerWeek: true,
  estimatedDuration: true,
  primaryFocusArea: true,
  startDate: true,
  worksite: true,
}).extend({
  addressCountryCode: z
    .enum(ZodArrayToEnum(selfServiceAllowedCountryCodeValues))
    .nullable(),
  companyLocation: SchemaLocation.superRefine((val, context) => {
    const addresses = val.locationAddressComponents?.addresses || [];

    const isUSLocation = addresses.some(
      address =>
        address.types.includes('country') && address.short_name === 'US'
    );

    const hasStreetAddress = addresses.some(address =>
      address.types.includes('route')
    );

    if (!hasStreetAddress || !isUSLocation) {
      context.addIssue({
        code: z.ZodIssueCode.custom,
        message: 'Must be a US address',
      });
    }
  }),
});

export type TalentInterviewMiniIntakeForm = z.infer<
  typeof TalentInterviewMiniIntakeModalSchema
>;
